<script lang='ts'>
import type { PropType } from 'vue'
import { defineComponent, onMounted, onUnmounted, ref, watch } from 'vue'
import { showErrorMessage } from '../utils'

export default defineComponent({
  name: 'MsEditor',
  props: {
    value: {
      type: String,
    },
    height: {
      type: Object as PropType<number | string>,
      default: '100%',
    },
    toolbar: {
      type: Object as PropType<boolean | string | string[]>,
      default: `undo redo | cut copy paste pastetext |
            forecolor backcolor bold italic underline strikethrough link |
            alignleft aligncenter alignright alignjustify outdent indent |
            styleselect fontsizeselect lineheight | bullist numlist |
            image addImg charmap emoticons hr blockquote removeformat |
            axupimgs | preview fullscreen help`,
    },
    plugins: {
      type: Object as PropType<string | string[]>,
      default: `preview searchreplace autolink directionality visualblocks visualchars fullscreen image
            link charmap hr nonbreaking insertdatetime advlist lists wordcount imagetools textpattern
            help emoticons autosave`,
    },
  },
  setup(props) {
    const id = `editor${new Date().getTime()}`
    const editorInit = ref(false)
    const dynamicLoadScript = (src: string) => {
      return new Promise((resolve, reject) => {
        const existingScript = document.getElementById(src)
        if (existingScript) resolve(null)
        if (!existingScript) {
          const script = document.createElement('script')
          script.src = src
          script.id = src
          document.body.appendChild(script)
          script.onload = resolve
          script.onerror = reject
        }
      })
    }

    const init = () => {
      window.tinymce.init({
        selector: `textarea#${id}`,
        skin: 'oxide',
        language: 'zh_CN',
        plugins: props.plugins,
        toolbar: props.toolbar,
        contextmenu: false,
        menubar: false,
        height: props.height,
        resize: false,
        branding: false,
        fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
        toolbar_mode: 'wrap',
        autosave_ask_before_unload: false,
        init_instance_callback: (editor) => {
          console.debug('init finish')
          editorInit.value = true
          if (props.value) {
            editor.setContent(props.value)
          }
        },
      })
    }

    watch(() => props.value, () => {
      window.tinymce?.get(id)?.setContent(props.value ?? '')
    })

    onMounted(() => {
      const tinymcePath = 'https://f.meishi.51baibao.com/web/lib/tinymce/js/tinymce/tinymce.min.js'
      dynamicLoadScript(tinymcePath)
        .then(() => init())
        .catch(() => showErrorMessage('编辑器加载失败'))
    })

    onUnmounted(() => {
      window.tinymce?.get(id)?.destroy()
    })

    const getContent = () => {
      return window.tinymce?.get(id)?.getContent() ?? ''
    }

    return {
      id,
      getContent,
    }
  },
})
</script>

<template>
  <div>
    <textarea :id="id" />
  </div>
</template>

<style>
</style>
